import { Outlet } from "react-router";

export function DocumentationsRoute() {
  return <Outlet />;
}
